module.exports = __webpack_public_path__ + "img/arrow-right.55aada42.svg";